import { Entity } from "./entity";
import { PrincipalWhatsNew } from "./principalWhatsNew";

export class WhatsNew extends Entity {
    ExpirationDate?: Date | null;
    Version: string;
    HtmlContent: string;
    Title: string;
    PrincipalWhatsNew: PrincipalWhatsNew[];
    
    // constructor(data?: any) {
    //     super()
    //     this.init(data);      
    // }

    // get State(): string | null {
    //     if (this.Disabled)
    //         return 'Disabled';
    //     return 'Enabled';
    // } 
    
   
    static newItem(): WhatsNew {

        let item = new WhatsNew();
        item.Id = 0;
        item.ExpirationDate = null;
        return item;
    }
}

export class WhatsNewSearchModel extends Entity {
    ExpirationDate?: Date;
    Version?: string;
    IsForUser?: boolean | null;
    PrincipalId?: number | null;
    OnlyActive?: boolean;
    Take?: number;
    QueryTitle: string | null;
    QueryId: number | null;
    PageDirection?: string;
}

